"use client"

import InViewWrapper from "~/components/layout/InViewWrapper";
import {motion, type Variants} from "framer-motion";
import Darek from "~/assets/contact/darek.png";
import Alena from "~/assets/contact/alena.png";
import type {StaticImport} from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import {Breakpoints, useView} from "~/hooks/useView";

export default function ContactCardSection() {
  const isMobileView = useView(Breakpoints.Mobile);

  return <>
    <section className="m-auto w-11/12 sm:w-11/12 xl:w-9/12">
      <InViewWrapper
        variant={{
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: isMobileView ? 0 : 0.2,
            },
          },
          hidden: { opacity: 0 },
        }}
        Element={motion.div}
      >
        <div className="mx-auto mt-12 flex w-full flex-wrap gap-12 xl:w-8/12 xl:flex-nowrap">
          <ContactCard
            photo={Darek}
            name="Darek Hrivňák"
            title="Zmrzlinář"
            email="zmrzlina@2ad.cz"
            variant={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          />
          <ContactCard
            photo={Alena}
            name="Alena Hrivňáková"
            title="Výrobkyně dortů"
            phone="603 293 341"
            email="2ad@2ad.cz"
            variant={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          />
        </div>
      </InViewWrapper>
    </section>
  </>
}

interface Props {
  photo: StaticImport;
  name: string;
  title: string;
  email: string;
  phone?: string;
  variant: Variants;
}

function ContactCard({ photo, name, title, email, phone, variant }: Props) {
  return (
    <>
      <motion.div
        className="w-full rounded-[32px] bg-white shadow-[0_4px_16px_0_rgba(0,0,0,0.08)]"
        variants={variant}
      >
        <Image src={photo} alt={name} className="rounded-t-[32px]" />
        <div className="flex flex-col p-[40px]">
          <h3 className="h3 !font-[800] text-primary">{name}</h3>
          <div className="mb-6 text-[16px] font-[400] text-primary">
            {title}
          </div>
          <p className="mt-12">
            {phone}
            <br />
            {email}
          </p>
        </div>
      </motion.div>
    </>
  );
}
